import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { IDEA_TEMPLATES } from '@/constants/dashboard';

const TemplateDialog = ({ open, onOpenChange, onSelect }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto bg-[var(--surface)] border border-[var(--border-default)] p-0" style={{ borderRadius: 0 }}>
        <DialogHeader className="p-6 sm:p-8 pb-4 sm:pb-6 border-b border-[var(--border-default)]">
          <DialogTitle className="text-2xl sm:text-3xl font-bold tracking-tight" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            Choose a Template
          </DialogTitle>
          <DialogDescription className="sr-only">
            Select a template to start your idea with a structured format
          </DialogDescription>
        </DialogHeader>
        
        <div className="p-6 sm:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {IDEA_TEMPLATES.map(template => (
              <button
                key={template.id}
                data-testid={`template-${template.id}`}
                onClick={() => onSelect(template)}
                className="bg-[var(--surface)] border-2 border-[var(--border-default)] p-6 hover:border-[var(--obsidian)] hover:-translate-y-2 hover:shadow-[4px_4px_0px_0px_rgba(10,10,10,1)] transition-all duration-200 text-left relative group overflow-hidden"
              >
                <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#FF3B30] via-[#007AFF] to-[#FFD60A] opacity-0 group-hover:opacity-100 transition-opacity duration-200"></div>
                
                <div className="text-2xl sm:text-3xl mb-3 group-hover:scale-110 transition-transform duration-200 inline-block">
                  {template.name}
                </div>
                <div className="text-xs font-mono uppercase tracking-wider text-[var(--text-secondary)] font-semibold">
                  {template.category}
                </div>
                
                <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  <span className="text-[var(--obsidian)] text-xl">&rarr;</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TemplateDialog;
